import { Flex, Image } from "@chakra-ui/react";

interface OnboardingImageProps {
  src: string;
}

export const OnboardingImage = (props: OnboardingImageProps) => {
  const { src } = props;
  return (
    <Flex
      paddingX="1"
      width="100%"
      background="background.primary"
      borderRadius="0.5rem"
      color="foreground.primary"
      justifyContent="space-between"
    >
      <Image src={src} />
    </Flex>
  );
};
